import { ElementRef, QueryList } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { asap } from 'rxjs/scheduler/asap';
import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/operator/subscribeOn';
import 'rxjs/add/operator/takeUntil';
import { ScrollService } from 'app/shared/scroll.service';
import { TocService } from 'app/shared/toc.service';
var TocComponent = /** @class */ (function () {
    function TocComponent(scrollService, elementRef, tocService) {
        this.scrollService = scrollService;
        this.tocService = tocService;
        this.activeIndex = null;
        this.type = 'None';
        this.isCollapsed = true;
        this.isEmbedded = false;
        this.onDestroy = new Subject();
        this.primaryMax = 4;
        this.isEmbedded = elementRef.nativeElement.className.indexOf('embedded') !== -1;
    }
    TocComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.tocService.tocList
            .takeUntil(this.onDestroy)
            .subscribe(function (tocList) {
            _this.tocList = tocList;
            var itemCount = count(_this.tocList, function (item) { return item.level !== 'h1'; });
            _this.type = (itemCount > 0) ?
                _this.isEmbedded ?
                    (itemCount > _this.primaryMax) ?
                        'EmbeddedExpandable' :
                        'EmbeddedSimple' :
                    'Floating' :
                'None';
        });
    };
    TocComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (!this.isEmbedded) {
            // We use the `asap` scheduler because updates to `activeItemIndex` are triggered by DOM changes,
            // which, in turn, are caused by the rendering that happened due to a ChangeDetection.
            // Without asap, we would be updating the model while still in a ChangeDetection handler, which is disallowed by Angular.
            Observable.combineLatest(this.tocService.activeItemIndex.subscribeOn(asap), this.items.changes.startWith(this.items))
                .takeUntil(this.onDestroy)
                .subscribe(function (_a) {
                var index = _a[0], items = _a[1];
                _this.activeIndex = index;
                if (index === null || index >= items.length) {
                    return;
                }
                var e = items.toArray()[index].nativeElement;
                var p = e.offsetParent;
                var eRect = e.getBoundingClientRect();
                var pRect = p.getBoundingClientRect();
                var isInViewport = (eRect.top >= pRect.top) && (eRect.bottom <= pRect.bottom);
                if (!isInViewport) {
                    p.scrollTop += (eRect.top - pRect.top) - (p.clientHeight / 2);
                }
            });
        }
    };
    TocComponent.prototype.ngOnDestroy = function () {
        this.onDestroy.next();
    };
    TocComponent.prototype.toggle = function (canScroll) {
        if (canScroll === void 0) { canScroll = true; }
        this.isCollapsed = !this.isCollapsed;
        if (canScroll && this.isCollapsed) {
            this.toTop();
        }
    };
    TocComponent.prototype.toTop = function () {
        this.scrollService.scrollToTop();
    };
    return TocComponent;
}());
export { TocComponent };
function count(array, fn) {
    return array.reduce(function (count, item) { return fn(item) ? count + 1 : count; }, 0);
}



// WEBPACK FOOTER //
// /home/wzc/dev/angular/angular/aio/src/app/layout/toc/toc.component.ts.pre-build-optimizer.js